import { Button, Form, type FormProps, Input, Modal } from 'antd';
import { createInquiry } from '@/services/api/chatService';
import { useTranslation } from 'react-i18next';

type FieldType = {
  name?: string;
};

const ModalCreateInquiry: any = ({ open, onOk, onCancel, project }: any) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const onFinish: FormProps<FieldType>['onFinish'] = async values => {
    const payload: any = {
      name: values.name,
    };
    const response: any = await createInquiry(payload, {
      project_id: project ? project?.id : {},
    });
    if (response?.success && response?.data) {
      onOk(response.data);
    }
    form.resetFields();
    onCancel();
  };

  return (
    <div>
      <Modal
        title={t('home.chat.modals.add.title')}
        open={open}
        destroyOnClose
        footer={
          <Button type="primary" onClick={() => form.submit()}>
            {t('home.chat.modals.add.confirm')}
          </Button>
        }
        onCancel={() => {
          form.resetFields();
          onCancel();
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            name="name"
            label={t('home.chat.modals.add.label')}
            rules={[
              {
                required: true,
                message: t('home.chat.modals.add.requiredMessage'),
              },
            ]}
          >
            <Input placeholder={t('home.chat.modals.add.placeholder')} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalCreateInquiry;
